import * as fromDatatype from '../datatype-library/index';

export interface bl_alg_cc_login_subject_link_RowInterface {
  guid : fromDatatype.GuidDataFieldInterface;
  login_subject_guid : fromDatatype.GuidDataFieldInterface;
  grp_hdr_guid : fromDatatype.GuidDataFieldInterface;
  virtual_contact_hdr_guid : fromDatatype.GuidDataFieldInterface;
  ext_type : fromDatatype.VarcharDatatypeInterface;
  ext_code : fromDatatype.VarcharDatatypeInterface;
  ext_option : fromDatatype.VarcharDatatypeInterface;
  property_json : fromDatatype.JsonDatatypeInterface;
  param_code : fromDatatype.VarcharDatatypeInterface;
  param_name : fromDatatype.VarcharDatatypeInterface;
  param_type : fromDatatype.VarcharDatatypeInterface;
  param_option_json : fromDatatype.JsonDatatypeInterface;
  value_string : fromDatatype.VarcharDatatypeInterface;
  value_file : fromDatatype.VarcharDatatypeInterface;
  value_numeric : fromDatatype.BigIntegerDatatypeInterface;
  value_datetime : fromDatatype.TimestampTzDatatypeInterface;
  value_json : fromDatatype.JsonDatatypeInterface;
  created_date : fromDatatype.TimestampTzDatatypeInterface;
  updated_date : fromDatatype.TimestampTzDatatypeInterface;
  status : fromDatatype.StatusDataFieldInterface
  revision : fromDatatype.VarcharDatatypeInterface;
  vrsn : fromDatatype.VarcharDatatypeInterface;
}

export class bl_alg_cc_login_subject_link_RowClass implements bl_alg_cc_login_subject_link_RowInterface {
  guid : fromDatatype.GuidDataFieldInterface;
  login_subject_guid : fromDatatype.GuidDataFieldInterface;
  grp_hdr_guid : fromDatatype.GuidDataFieldInterface;
  virtual_contact_hdr_guid : fromDatatype.GuidDataFieldInterface;
  ext_type : fromDatatype.VarcharDatatypeInterface;
  ext_code : fromDatatype.VarcharDatatypeInterface;
  ext_option : fromDatatype.VarcharDatatypeInterface;
  property_json : fromDatatype.JsonDatatypeInterface;
  param_code : fromDatatype.VarcharDatatypeInterface;
  param_name : fromDatatype.VarcharDatatypeInterface;
  param_type : fromDatatype.VarcharDatatypeInterface;
  param_option_json : fromDatatype.JsonDatatypeInterface;
  value_string : fromDatatype.VarcharDatatypeInterface;
  value_file : fromDatatype.VarcharDatatypeInterface;
  value_numeric : fromDatatype.BigIntegerDatatypeInterface;
  value_datetime : fromDatatype.TimestampTzDatatypeInterface;
  value_json : fromDatatype.JsonDatatypeInterface;
  created_date : fromDatatype.TimestampTzDatatypeInterface;
  updated_date : fromDatatype.TimestampTzDatatypeInterface;
  status : fromDatatype.StatusDataFieldInterface
  revision : fromDatatype.VarcharDatatypeInterface;
  vrsn : fromDatatype.VarcharDatatypeInterface;
}
